import { Box } from '@chakra-ui/react'
import React from 'react'

export const StickyContainer = ({
  children,
}: {
  children: React.ReactNode
}) => (
  <Box
    id="letter-container"
    position={'sticky'}
    top={0}
    padding={'20px 0'}
    backgroundColor={'#f4f4f4'}
  >
    {children}
  </Box>
)
